import { RouteRecordRaw } from "vue-router";
import Layout from "@/views/layouts/index.vue";

const dataAnalysisRouter: RouteRecordRaw[] = [
    {
        path: "/dataAnalysis",
        name: "DataAnalysis",
        component: Layout,
        redirect: "/dataAnalysis/dashboard",
        meta: {
            title: "数据分析",
            icon: "icon-zhishu"
        },
        children: [
            {
                path: "/dataAnalysis/dashboard",
                name: "Dashboard",
                component: () => import("@/views/pages/dataAnalysis/dashboard/index.vue"),
                meta: {
                    title: "数据看板",
                    isNotShowHeader: true
                }
            },
            {
                path: "/dataAnalysis/screen",
                name: "SupervisionScreen",
                component: () => import("@/views/pages/dataAnalysis/supervisionScreen/index.vue"),
                meta: {
                    title: "监管大屏",
                    isNotShowHeader: true
                }
            },
            {
                path: "/dataAnalysis/logistics",
                name: "LogisticsAnalysis",
                component: () => import("@/views/pages/dataAnalysis/logisticsAnalysis/index.vue"),
                meta: {
                    title: "物流分析",
                    isNotShowHeader: true
                }
            }
        ]
    }
];

export default dataAnalysisRouter;
